'use strict';

var Radio = require('backbone.radio');
var _ = require('underscore');
var $ = require('jquery');

require('intl-tel-input/build/js/intlTelInput.min');
require('intl-tel-input/build/js/utils');

var polyglot = require('../../utilities/polyglot').default;

var FormView = require('../form').default;

export default FormView.extend({

  className: 'form wait-list-form',
  template: require('./templates/form.hbs'),
  events: {
    'change #location': 'onChangeLocation',
    'change #service': 'onKeyUp',
    'keyup #modal-first-name,#modal-last-name,#modal-email,#modal-cell-phone,#request,#receive_sms': 'onKeyUp',
  },
  regions: {
    buttons: '.form-buttons',
  },
  ui: {
    location_id: '#location',
    service_id: '#service',
    first_name: '#modal-first-name',
    last_name: '#modal-last-name',
    email: '#modal-email',
    cell_phone: '#modal-cell-phone',
    request: '#request',
    receive_sms: '#receive_sms',
  },
  submit: {
    className: 'button full',
    text: polyglot.t('wait_list.send_request'),
  },

  initialize: function (options) {
    this.locations = options.locations;
    this.services = options.services;
    this.smsEnabled = options.smsEnabled;
    this.model.set('booked_through', window.CONSTANTS.ORIGIN_CLIENT_VIEW);

    this.listenTo(this, 'submit', this.onValidSubmit);
    this.listenTo(Radio.channel('windows'), 'close', this.onCloseModal);
  },

  serializeData: function () {
    var json = this.model.toJSON();
    json.showMobilePhone = this.model.showMobilePhone();
    json.isMobilePhoneRequired = this.model.isMobilePhoneRequired();
    json.showSmsBox = window.SETTINGS.auto_sms_opt_in ? false : this.smsEnabled;
    json.showLocations = this.showLocations();
    json.locations = this.locations.toJSON();
    json.services = this.services.toJSON();
    return json;
  },

  showLocations: function () {
    if (this.locations.length < 1) {
      return false;
    }

    return !(window.SETTINGS.hide_location_step && this.locations.length === 1);
  },

  onRender: function () {
    FormView.prototype.onRender.call(this, arguments);

    if (this.model.has('location_id')) {
      this.ui.location_id.val(this.model.get('location_id'));
    }

    if (this.model.has('service_id')) {
      this.ui.service_id.val(this.model.get('service_id'));
    }

    this.renderIntlTelInputs();
  },

  renderIntlTelInputs: function () {
    this.ui.cell_phone.intlTelInput({
      nationalMode: true,
      initialCountry: 'auto',
      geoIpLookup: function (callback) {
        $.get('https://ipinfo.io', function() {}, 'jsonp').always(function(resp) {
          var countryCode = (resp && resp.country) ? resp.country : 'US';
          callback(countryCode);
        });
      },
    });
  },

  onChangeLocation: function () {
    this.model.set('location_id', this.ui.location_id.val());
    this.model.unset('service_id');

    var self = this;
    this.services.fetch({
      data: {
        location_id: self.model.get('location_id'),
      },
      success: function () {
        self.render();
      },
    });
  },

  onCloseModal: function () {
    Radio.channel('modal').trigger('hide');
    Radio.channel('windows').trigger('focusWaitlist');
  },

  onValidSubmit: function () {
    if (!this.model.isMobilePhoneRequired() && !$(this.ui.cell_phone).val()) {
      this.model.unset('cell_phone');
    }
    this.model.save({
      _token: $('meta[name="csrf-token"]').attr('content'),
    }, {
      success: _.bind(this.onSaveSuccess, this),
      error: _.bind(this.onSaveError, this),
    });
  },

  onSaveSuccess: function (model, response, options) {
    this.enableSubmit();
    Radio.channel('modal').trigger('hide');

    Radio.channel('toast').trigger('show', {
      message: response.message || polyglot.t('wait_list.success'),
      iconColor: 'success',
    });
  },

  onSaveError: function (model, response, options) {
    this.enableSubmit();
    Radio.channel('toast').trigger('show', {
      message: response.message || polyglot.t('wait_list.error'),
      iconColor: 'error',
    });
  },

  updateModel: function () {
    this.model.set('location_id', this.ui.location_id.val());
    this.model.set('service_id', this.ui.service_id.val());
    this.model.set('first_name', this.ui.first_name.val());
    this.model.set('last_name', this.ui.last_name.val());
    this.model.set('email', this.ui.email.val());
    this.model.set('cell_phone', this.ui.cell_phone.intlTelInput('getNumber'));
    this.model.set('request', this.ui.request.val());
    this.model.set('receive_sms', window.SETTINGS.auto_sms_opt_in || this.ui.receive_sms.prop('checked'));
    this.model.set('lang', $('html').attr('lang'));
  },
});
